import { ACCOUNT_TYPE } from "./constant";
import { HiUserAdd } from "react-icons/hi";
import { IoLibrary } from "react-icons/io5";
import { GiNotebook } from "react-icons/gi";
import { RiLogoutBoxLine } from "react-icons/ri";
import { FaHistory } from "react-icons/fa";
import { IoMdAddCircleOutline } from "react-icons/io";
import { MdOutlineSettings } from "react-icons/md";
import { FaUsers } from "react-icons/fa6";
import { TbCategoryPlus } from "react-icons/tb";
import { AiOutlineDashboard } from "react-icons/ai";



export const sidebarLinks = [
  {
    id: 123,
    name: "Dashboard",
    path: "/dashboard/dashboard-main",
    type: ACCOUNT_TYPE.LIBRARIAN,
    icon: <AiOutlineDashboard />
    ,
  },
  {
    id: 1,
    name: "Accessing",
    path: "/dashboard/add-book",
    type: ACCOUNT_TYPE.LIBRARIAN,
    icon: <IoMdAddCircleOutline />  ,
  },
  {
    id: 3,
    name: "Add Catelog",
    path: "/dashboard/add-category",
    type: ACCOUNT_TYPE.LIBRARIAN,
    icon: <TbCategoryPlus />,
  },
  {
    id: 4,
    name: "Register Student",
    path: "/dashboard/add-student",
    type: ACCOUNT_TYPE.LIBRARIAN,
    icon: <HiUserAdd/>,
  },
  {
    id: 5,
    name: "All Student",
    path: "/dashboard/all-student",
    type: ACCOUNT_TYPE.LIBRARIAN,
    icon: <FaUsers />,
  },
  {
    id: 6,
    name: "All Books",
    path: "/dashboard/all-book",
    icon: <IoLibrary/>,
  },
 
  {
    id: 7,
    name: "Classifaction",
    path: "/dashboard/transication-book",
    type: ACCOUNT_TYPE.LIBRARIAN,
    icon: <FaHistory/>,
  },
  {
    id: 8,
    name: "Setting",
    path: "/dashboard/setting",
    icon: <MdOutlineSettings />,

        },
        {
          id: 10,
          name: "Transication Book",
          path: "/dashboard/transication-book",
          type: ACCOUNT_TYPE.STUDENT,
          icon: <FaHistory/>,
        },
];
